import { Box, Stack, Typography } from '@mui/material';

/**
 * Standard page header: title (+ optional description) on the left,
 * an optional action slot (property switcher, buttons) on the right.
 */
export default function PageHeader({ title, description, action, sx }) {
  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between" gap={2} sx={{ mb: 3, ...sx }}>
      <Box>
        <Typography variant="h3" component="h1">
          {title}
        </Typography>
        {description && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {description}
          </Typography>
        )}
      </Box>
      {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
    </Stack>
  );
}
